import "./Insights.module.css";
import MainNavigation from "@/reusable_sections/Header";
import MaximizeYourValue from "./sections/MaximizeYourValue";
import MarketWisdom from "./sections/MarketWisdom";
import BlogGrid from "./sections/BlogGrid";
import Footer from "@/reusable_sections/Footer";
export default function InsightsPage() {
  return <div>
      <MainNavigation />
      <MaximizeYourValue />
      <MarketWisdom />
      <BlogGrid />
      <Footer />
    </div>;
}